import React from "react"
// import NavigationItem from "./NavigationItem/NavigationItem";
// import { Image } from "react-bootstrap";

import Logout from "../Logout/Logout";


import classes from "./NavigationItems.module.css"

// import notifications from "../../../assets/images/notifications.png"

const navigationItems = () => (
  <ul className={classes.NavigationItems}>
  {/* <NavigationItem link="/notification">
        <Image src={notifications} alt="notifications" />
      </NavigationItem> */}
      {/* <LanguageSwitch/> */}
    <Logout/>
  </ul>
);
export default navigationItems